import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const location = useLocation();
    const [navOpen, setNavOpen] = useState(false);
    const [solidBar, setSolidBar] = useState(() => location.pathname !== '/');

    const updateSolidBar = useCallback(() => {
        if (location.pathname !== '/') {
            setSolidBar(true);
            return;
        }
        const hero = document.querySelector('.hero-liquid');
        if (!hero) {
            setSolidBar(true);
            return;
        }
        const { bottom } = hero.getBoundingClientRect();
        setSolidBar(bottom < 72);
    }, [location.pathname]);

    useEffect(() => {
        setNavOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const run = () => {
            requestAnimationFrame(updateSolidBar);
        };
        run();
        window.addEventListener('scroll', run, { passive: true });
        window.addEventListener('resize', run);
        return () => {
            window.removeEventListener('scroll', run);
            window.removeEventListener('resize', run);
        };
    }, [updateSolidBar]);

    useEffect(() => {
        if (navOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [navOpen]);

    const closeNav = () => setNavOpen(false);

    const navClass = (path) => {
        const active = location.pathname === path;
        return `site-header__nav-link${active ? ' site-header__nav-link--active' : ''}`;
    };

    const showSolid = solidBar || navOpen;

    return (
        <header
            className={`site-header text-white${showSolid ? ' site-header--solid' : ' site-header--transparent'}`}
        >
            {navOpen ? (
                <button
                    type="button"
                    className="site-header__backdrop"
                    aria-label="Cerrar menú"
                    onClick={closeNav}
                />
            ) : null}
            <div className="container position-relative" style={{ zIndex: 1001 }}>
                <div className="site-header__inner py-1 py-md-2">
                    <div className="site-header__grid-start d-none d-lg-block" aria-hidden="true" />
                    {showSolid ? (
                        <span className="site-header__name" lang="es">
                            Benjamín Méndez
                        </span>
                    ) : null}
                    <button
                        type="button"
                        className={`site-header__hamburger d-lg-none${navOpen ? ' is-active' : ''}`}
                        onClick={() => setNavOpen((o) => !o)}
                        aria-expanded={navOpen}
                        aria-controls="site-nav-menu"
                        aria-label={navOpen ? 'Cerrar menú' : 'Abrir menú'}
                    >
                        <span className="site-header__hamburger-bar" aria-hidden />
                        <span className="site-header__hamburger-bar" aria-hidden />
                        <span className="site-header__hamburger-bar" aria-hidden />
                    </button>
                    <nav
                        id="site-nav-menu"
                        className={`site-header__nav site-header__nav--main${navOpen ? ' is-open' : ''}`}
                        aria-label="Principal"
                    >
                        <Link to="/" className={navClass('/')} onClick={closeNav}>Inicio</Link>
                        <a href="/#about" className="site-header__nav-link" onClick={closeNav}>Sobre mí</a>
                        <a href="/#experience" className="site-header__nav-link" onClick={closeNav}>Experiencia</a>
                        <a href="/#education" className="site-header__nav-link" onClick={closeNav}>Educación</a>
                        <Link to="/transportes" className={navClass('/transportes')} onClick={closeNav}>Transportes</Link>
                        <Link to="/screensaver" className={navClass('/screensaver')} onClick={closeNav}>Screensaver</Link>
                        <a href="/#contact" className="site-header__nav-link" onClick={closeNav}>Contacto</a>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;
